/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        var viewportWidth = $(window).width();

        // Fastclick
        FastClick.attach(document.body);

        // Mobile Dropdown
        /*if (viewportWidth > 1024) {
          $('.mobile-touch').addClass('disabled');
          $('.mobile-touch').hide();
        } else {
          if ($('.mobile-touch').length) {
            $('.mobile-touch').dropdown();
          }
        }*/

        if ($('.js-carousel-gallery').length) {
          $('.js-carousel-gallery').slick({
            arrows: false,
            dots: false,
            fade: false,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 15000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        }

        if ($('.js-carousel-nav').length) {
          $('.js-carousel-nav').slick({
            arrows: true,
            asNavFor: '.js-carousel-gallery',
            dots: false,
            focusOnSelect: true,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '60px',
            nextArrow: '<div class="next mr-15"><i class="fas fa-chevron-right text-white"></i></div>',
            prevArrow: '<div class="prev ml-15"><i class="fas fa-chevron-left text-white"></i></div>',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  centerMode: true,
                  slidesToShow: 1,
                  centerPadding: '60px',
                },
              },
            ],
          });
        }

        
        // Menu
        $('.c-mobile__menu-trigger').click(function(){
          $(this).toggleClass('active');

          $('.c-mobile__nav').toggleClass('active');
        });

        // Remove empty p tags
        $('p:empty').remove();

        // External Links.
        $('a').filter(function(){
          return this.hostname && this.hostname !== location.hostname;
        }).addClass('external').attr('target', '_blank');

        // Lazy load images
        $('img').unveil(50);
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
          if (!Cookies.get('popup')) {
            setTimeout(function () {
              $.fancybox.open({
                src: '.popup-overlay',
                type: 'inline'
              });

            Cookies.set('popup', 'true', { expires: 1 });
          }, 1000);
        }
      }


    },
    // Home page
    'home': {
      init: function() {
        // Owl carousel
        /*$('.c-hero__carousel').owlCarousel({
          items: 1,
          loop: true,
          autoplay: true
        });*/

        $('.c-testimonials__carousel').owlCarousel({
          items: 1,
          loop: true,
          autoplay: true,
          autoplayTimeout: 10000,
          responsiveClass: true,
          responsive: {
            768: {
              items: 2
            },
            992: {
              items: 3
            }
          }
        });
      },
      finalize: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
